import { render, staticRenderFns } from "./Servicios.vue?vue&type=template&id=6f01dece&"
import script from "./Servicios.vue?vue&type=script&lang=js&"
export * from "./Servicios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports